import { INTERACTION_TYPES } from '@cult/domain';
import type { PublicPraise } from '@cult/schemas';
import { Link, useNavigate } from '@tanstack/react-router';
import { Flex, Typography } from 'antd';
import { FeedCard, RelativeTime, SenderRecipient } from '../../../../components';
import { stripMarkdown } from '../../../../lib/markdown';
import { INTERACTION_TYPE_META, InteractionTypeBadge } from '../../../interactions';
import { ReferenceTags } from '../../../reference';
import styles from './PraiseRow.module.scss';

const { Text, Title, Paragraph } = Typography;

type Props = {
  praise: PublicPraise;
  index?: number;
};

export const PraiseRow = ({ praise, index = 0 }: Props) => {
  const navigate = useNavigate();
  const accent = praise.coreValues[0]?.color ?? INTERACTION_TYPE_META[INTERACTION_TYPES.PRAISE].accent;

  const open = () => navigate({ to: '/praise/$id', params: { id: String(praise.number) } });

  return (
    <FeedCard vertical accent={accent} index={index} onClick={open}>
      <Flex vertical gap={8} className={styles.header}>
        <InteractionTypeBadge type={INTERACTION_TYPES.PRAISE} />
        <SenderRecipient author={praise.author} receiver={praise.receiver} avatarSize={28} />
      </Flex>

      <Link
        to="/praise/$id"
        params={{ id: String(praise.number) }}
        onClick={(e) => e.stopPropagation()}
        style={{ color: 'inherit', textDecoration: 'none' }}
      >
        <Title level={5} className={styles.title}>
          {praise.title}
        </Title>
      </Link>

      <Paragraph type="secondary" className={styles.what} ellipsis={{ rows: 4 }}>
        {stripMarkdown(praise.whatHappened)}
      </Paragraph>

      <Text className={styles.behavior}>{praise.behavior}</Text>

      <Flex align="center" justify="space-between" gap={8} wrap>
        <ReferenceTags tags={praise} />
        <RelativeTime date={praise.createdAt} />
      </Flex>
    </FeedCard>
  );
};
